import { useEffect, useRef } from 'react';
import { useUnreadInbox } from '../context/UnreadInboxContext';
import { useAuth } from '../context/AuthContext';
import { applyTabUnreadBadge, resetTabUnreadBadge } from '../utils/tabUnreadBadge';

/**
 * Zeigt ungelesene Mails im Browser-Tab (Titel + Favicon-Badge).
 */
export default function UnreadTabIndicator() {
  const { isAuthenticated } = useAuth();
  const { unreadCount } = useUnreadInbox();
  const genRef = useRef(0);

  useEffect(() => {
    if (!isAuthenticated) {
      resetTabUnreadBadge();
      return undefined;
    }

    const gen = ++genRef.current;
    let cancelled = false;

    const run = async () => {
      await applyTabUnreadBadge(unreadCount);
      if (cancelled || gen !== genRef.current) return;
    };

    run();

    // Wenn der Tab wieder sichtbar wird, Badge/Titel nochmal setzen
    // (manche Browser setzen Favicon bei Fokus zurück)
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        applyTabUnreadBadge(unreadCount);
      }
    };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [isAuthenticated, unreadCount]);

  useEffect(() => {
    return () => {
      resetTabUnreadBadge();
    };
  }, []);

  return null;
}
